/* Shto home: the Relaxe homepage sections (sections/shto-home-*.liquid). Runs once, for every section on the page,
   and again for a section re-rendered in the theme editor.
   - Hero: the poster shows straight away. The animation for this screen size loads after the page has loaded and plays
     (muted, looping) while the hero is on screen; it fades in over the poster once it is actually playing. Never with
     reduced motion or data saver.
   - Affirm: copies Affirm's own monthly amount (.affirm-ala-price) into each "as low as" line. No amount: the line stays
     hidden (or its fallback text shows).
   - Sauna sizes: the picked size sets the price, the Affirm amount and the button's ?variant=.
   - Swipe rows: the progress bar follows the row. */
(function () {
  if (window.ShtoHome) return;
  window.ShtoHome = true;

  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = navigator.connection && navigator.connection.saveData;
  var desktop = window.matchMedia('(min-width: 1024px)');

  /* ---------- hero ---------- */
  function hero(root) {
    root.querySelectorAll('[data-shto-home-hero]').forEach(function (sec) {
      if (sec.__shtoHome) return; sec.__shtoHome = true;
      var vids = sec.querySelectorAll('video[data-shto-hero-video]');
      if (!vids.length) return;
      var onScreen = true;

      function want() { return desktop.matches ? 'desktop' : 'mobile'; }
      function sync() {
        vids.forEach(function (v) {
          var mine = v.getAttribute('data-shto-hero-video') === want();
          if (!mine || still.matches || saveData || !onScreen) {
            if (!v.paused) v.pause();
            if (still.matches) v.classList.remove('is-playing');
            return;
          }
          if (!v.getAttribute('src')) {
            v.setAttribute('src', v.getAttribute('data-src'));
            v.preload = 'auto';
            v.addEventListener('playing', function () { v.classList.add('is-playing'); });
            v.load();
          }
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; if (started) sync(); }, { threshold: 0.05 }).observe(sec);
      }
      var started = false;
      function start() { started = true; sync(); }
      if (document.readyState === 'complete') setTimeout(start, 0);
      else window.addEventListener('load', function () { setTimeout(start, 0); }, { once: true });
      desktop.addEventListener && desktop.addEventListener('change', function () { if (started) sync(); });
      still.addEventListener && still.addEventListener('change', function () { if (started) sync(); });
      document.addEventListener('visibilitychange', function () {
        if (!started) return;
        if (document.hidden) vids.forEach(function (v) { v.pause(); }); else sync();
      });
    });
  }

  /* ---------- Affirm ---------- */
  function affirmCopy(root) {
    var lines = (root || document).querySelectorAll('[data-shto-home-affirm]');
    var missing = 0;
    lines.forEach(function (wrap) {
      var p = wrap.querySelector('[data-shto-home-affirm-src] .affirm-ala-price');
      var line = wrap.querySelector('[data-shto-home-affirm-line]');
      var fb = wrap.querySelector('[data-shto-home-affirm-fallback]');
      var amount = p && p.textContent.trim();
      if (amount && /\d/.test(amount) && !/^\$?0(\.00)?$/.test(amount)) {
        var slot = wrap.querySelector('[data-shto-home-affirm-amount]');
        if (slot) slot.textContent = amount.charAt(0) === '$' ? amount : '$' + amount;
        if (line) line.hidden = false;
        if (fb) fb.hidden = true;
      } else {
        missing++;
        if (line) line.hidden = true;
        if (fb) fb.hidden = false;
      }
    });
    return missing;
  }
  var affirmReady = false;
  function affirmRefresh() {
    if (!affirmReady) return;
    try { window.affirm.ui.refresh(); } catch (e) {}
    var n = 0;
    (function poll() { if (affirmCopy() && n++ < 40) setTimeout(poll, 150); })();
  }
  (function waitAffirm(tries) {
    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.ready === 'function') {
      window.affirm.ui.ready(function () { affirmReady = true; affirmRefresh(); });
    } else if (tries < 100) setTimeout(function () { waitAffirm(tries + 1); }, 150);
    else affirmCopy();
  })(0);

  /* ---------- sauna sizes ---------- */
  function saunas(root) {
    root.querySelectorAll('[data-shto-home-sauna]').forEach(function (card) {
      if (card.__shtoHome) return; card.__shtoHome = true;
      var opts = card.querySelectorAll('.shto-home-size__opt');
      var first = opts[0];
      card.addEventListener('click', function (e) {
        var b = e.target.closest('.shto-home-size__opt');
        if (!b || b.disabled) return;
        opts.forEach(function (o) { o.setAttribute('aria-checked', o === b ? 'true' : 'false'); });
        var price = card.querySelector('[data-shto-home-price]');
        if (price) price.textContent = b.getAttribute('data-price-text');
        var from = card.querySelector('[data-shto-home-from]');
        if (from) from.hidden = b !== first;
        var link = card.querySelector('[data-shto-home-sauna-link]');
        if (link) link.href = card.getAttribute('data-url') + '?variant=' + b.getAttribute('data-id');
        var src = card.querySelector('[data-shto-home-affirm-src]');
        if (src) {
          src.setAttribute('data-amount', b.getAttribute('data-price'));
          var old = src.querySelector('.affirm-ala-price'); if (old) old.textContent = '';
          affirmRefresh();
        }
      });
      card.addEventListener('keydown', function (e) {
        var b = e.target.closest('.shto-home-size__opt');
        if (!b || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
        var list = Array.prototype.filter.call(opts, function (o) { return !o.disabled; });
        var i = list.indexOf(b) + (e.key === 'ArrowRight' ? 1 : -1);
        var next = list[(i + list.length) % list.length];
        e.preventDefault(); next.focus(); next.click();
      });
    });
  }

  /* ---------- swipe rows: progress ---------- */
  function rails(root) {
    root.querySelectorAll('[data-shto-home-rail]').forEach(function (rail) {
      if (rail.__shtoHome) return; rail.__shtoHome = true;
      var bar = rail.parentNode.querySelector('[data-shto-home-progress]');
      if (!bar) return;
      var ticks = bar.children;
      var raf = 0;
      function update() {
        raf = 0;
        var items = rail.children;
        if (!items.length) return;
        var max = Math.max(1, rail.scrollWidth - rail.clientWidth);
        var at = Math.round((rail.scrollLeft / max) * (items.length - 1));
        for (var i = 0; i < ticks.length; i++) ticks[i].classList.toggle('is-on', i === at);
      }
      rail.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
      // shto-swipe moves the row with scrollLeft, which still fires scroll; keep a light poll as a backstop.
      rail.addEventListener('pointerup', function () { setTimeout(update, 400); });
      update();
    });
  }

  function init(root) { hero(root); saunas(root); rails(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); affirmRefresh(); });
})();
